"use client";

import { createIcon } from "@chakra-ui/react";

const ArrowLeftSvgIcon = createIcon({
  displayName: "ArrowLeftSvgIcon",
  viewBox: "0 0 24 24",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" d="M1.58579 12L10 3.58576L11.4142 4.99997L5.41421 11L22 11L22 13L5.41422 13L11.4142 19L10 20.4142L1.58579 12Z" fill=""/>
  ),
});

export default ArrowLeftSvgIcon;
